'use client';

import { useMemo, useState } from 'react';
import classNames from 'classnames';

import Slider from './Slider';
import Map from 'app/components/common/Map';
import { IBranchPreview } from 'app/interfaces/branches';
import { IBranchContactsSliderTheme } from 'app/interfaces/ui';
import { branchContactsSliderThemes } from 'app/utility/themes';
import { IMapPlace } from 'app/interfaces/map';

export default function BranchContacts({
  branches,
  className,
  sliderTheme = branchContactsSliderThemes.light
}: {
  branches: IBranchPreview[];
  className?: string;
  sliderTheme?: IBranchContactsSliderTheme;
}) {
  const [activeItemId, setActiveItemId] = useState<string | number | null>(
    null
  );

  const places = useMemo<IMapPlace[]>(() => {
    return branches
      .filter(branch => branch.coordinates !== null)
      .map(branch => {
        return {
          id: branch.id,
          title: branch.name,
          coordinates: branch.coordinates
        };
      }) as IMapPlace[];
  }, [branches]);

  const onMouseEnter = (id: number | string) => {
    setActiveItemId(id);
  };

  const onMouseLeave = (id: number | string) => {
    setActiveItemId(null);
  };

  return (
    <section className="relative wrapper-max z-30">
      <Slider
        branches={branches}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        className={classNames(className)}
        theme={sliderTheme}
      />
      <div className="w-full wrapper-main wrapper-max pt-1.5 md:pt-4 xl:pt-5">
        <div className="relative overflow-hidden h-[340px] md:h-100 md:pb-0 rounded isolate">
          <Map places={places} activePlaceId={activeItemId} />
        </div>
      </div>
    </section>
  );
}
